const BUSINESS_TYPES = [
	{
		label: 'Agricultural Merchant / Farm Store',
		value: 'Agricultural Merchant / Farm Store',
		id: 'agricultural_merchant_farm_store',
	},
	{
		label: 'Animal Shelter / Charity',
		value: 'Animal Shelter / Charity',
		id: 'animal_shelter_charity',
	},
	{
		label: 'Backgrounder Lot',
		value: 'Backgrounder Lot',
		id: 'backgrounder_lot',
	},
	{
		label: 'Beef Producer',
		value: 'Beef Producer',
		id: 'beef_producer',
	},
	{label: 'Broilers', value: 'Broilers', id: 'broilers'},
	{
		label: 'Buying Group',
		value: 'Buying Group',
		id: 'buying_group',
	},
	{
		label: 'Calf Production',
		value: 'Calf Production',
		id: 'calf_production',
	},
	{
		label: 'Calf Ranch/Developer',
		value: 'Calf Ranch/Developer',
		id: 'calf_ranch_developer',
	},
	{label: 'Cattle Buyer', value: 'Cattle Buyer', id: 'cattle_buyer'},
	{
		label: 'Contract Grower',
		value: 'Contract Grower',
		id: 'contract_grower',
	},
	{label: 'Cooperative', value: 'Cooperative', id: 'cooperative'},
	{
		label: 'Corporate Office',
		value: 'Corporate Office',
		id: 'corporate_office',
	},
	{
		label: 'Cow/Calf Operation',
		value: 'Cow/Calf Operation',
		id: 'cow_calf_operation',
	},
	{
		label: 'Dairy Production',
		value: 'Dairy Production',
		id: 'dairy_production',
	},
	{
		label: 'Distributor / Agent',
		value: 'Distributor / Agent',
		id: 'distributor_agent',
	},
	{label: 'Feed Mill', value: 'Feed Mill', id: 'feed_mill'},
	{label: 'Feedyard', value: 'Feedyard', id: 'feedyard'},
	{
		label: 'Grower/Growyard',
		value: 'Grower/Growyard',
		id: 'grower_growyard',
	},
	{label: 'Hatchery', value: 'Hatchery', id: 'hatchery'},
	{
		label: 'Heifer Production',
		value: 'Heifer Production',
		id: 'heifer_production',
	},
	{
		label: 'Layer Integration',
		value: 'Layer Integration',
		id: 'layer_integration',
	},
	{label: 'Layers', value: 'Layers', id: 'layers'},
	{label: 'Media', value: 'Media', id: 'media'},
	{
		label: 'Milk Cooperative/Buyer',
		value: 'Milk Cooperative/Buyer',
		id: 'milk_cooperative_buyer',
	},
	{
		label: 'Mixed/Other Producer',
		value: 'Mixed/Other Producer',
		id: 'mixed_other_producer',
	},
	{
		label: 'Nutrient Supplier',
		value: 'Nutrient Supplier',
		id: 'nutrient_supplier',
	},
	{
		label: 'Packer/Processor',
		value: 'Packer/Processor',
		id: 'packer_processor',
	},
	{
		label: 'Pet Retail Outlet',
		value: 'Pet Retail Outlet',
		id: 'pet_retail_outlet',
	},
	{label: 'Pharmacy', value: 'Pharmacy', id: 'pharmacy'},
	{
		label: 'Poultry Breeder',
		value: 'Poultry Breeder',
		id: 'poultry_breeder',
	},
	{
		label: 'Poultry Integrator',
		value: 'Poultry Integrator',
		id: 'poultry_integrator',
	},
	{label: 'Sheep Producer', value: 'Sheep Producer', id: 'sheep_producer'},
	{
		label: 'Stocker Operation',
		value: 'Stocker Operation',
		id: 'stocker_operation',
	},
	{
		label: 'Stockyard/Salebarn',
		value: 'Stockyard/Salebarn',
		id: 'stockyard_salebarn',
	},
	{label: 'Swine Producer', value: 'Swine Producer', id: 'swine_producer'},
	{label: 'Turkeys', value: 'Turkeys', id: 'turkeys'},
	{
		label: 'University / Education',
		value: 'University / Education',
		id: 'university_education',
	},
	{
		label: 'Veterinary Practice',
		value: 'Veterinary Practice',
		id: 'veterinary_practice',
	},
	{
		label: 'Wholesaler / Retailer',
		value: 'Wholesaler / Retailer',
		id: 'wholesaler_retailer',
	},
	{label: 'Wool Buyer', value: 'Wool Buyer', id: 'wool_buyer'},
]

const ROLES = [
	{value: 'Academic', label: 'Academic', id: 'academic'},
	{
		value: 'Animal Welfare - Other',
		label: 'Animal Welfare - Other',
		id: 'animal_welfare_other',
	},
	{
		value: 'Animal Welfare - Retail Staff',
		label: 'Animal Welfare - Retail Staff',
		id: 'animal_welfare_retail_staff',
	},
	{
		value: 'Animal Welfare - Vet',
		label: 'Animal Welfare - Vet',
		id: 'animal_welfare_vet',
	},
	{
		value: 'Animal Welfare - Vet Nurse',
		label: 'Animal Welfare - Vet Nurse',
		id: 'animal_welfare_vet_nurse',
	},
	{
		value: 'Animal Welfare - Volunteer',
		label: 'Animal Welfare - Volunteer',
		id: 'animal_welfare_volunteer',
	},
	{
		value: 'Beef / Feedlot Extension',
		label: 'Beef / Feedlot Extension',
		id: 'beef_feedlot_extension',
	},
	{
		value: 'Beef Producer',
		label: 'Beef Producer',
		id: 'beef_producer',
	},
	{value: 'Breeder', label: 'Breeder', id: 'breeder'},
	{
		value: 'Business Administrator / Receptionist',
		label: 'Business Administrator / Receptionist',
		id: 'business_administrator_receptionist',
	},
	{
		value: 'Business Owner / Partner',
		label: 'Business Owner / Partner',
		id: 'business_owner_partner',
	},
	{
		value: 'Consulting Nutritionist',
		label: 'Consulting Nutritionist',
		id: 'consulting_nutritionist',
	},
	{
		value: 'Corporate Employee Non DVM',
		label: 'Corporate Veterinary Employee (non-hospital)',
		id: 'corporate_employee_non_dvm',
	},
	{
		value: 'Dairy Producer',
		label: 'Dairy Producer',
		id: 'dairy_producer',
	},
	{value: 'Distributor', label: 'Distributor', id: 'distributor'},
	{
		value: 'Distributor Rep, Field Based',
		label: 'Distributor Rep, Field Based',
		id: 'distributor_rep_field_based',
	},
	{
		value: 'Distributor Rep, Inside',
		label: 'Distributor Rep, Inside',
		id: 'distributor_rep_inside',
	},
	{
		value: 'Educational Institution - Highschool Student',
		label: 'Educational Institute - Highschool Student',
		id: 'educational_institution_highschool_student',
	},
	{
		value: 'Educational Institution - TAFE Student',
		label: 'Educational Institute - TAFE Student',
		id: 'educational_institution_tafe_student',
	},
	{
		value: 'Educational Institution - University Student',
		label: 'Educational Institute - University Student',
		id: 'educational_institution_university_student',
	},
	{value: 'Groomer', label: 'Groomer', id: 'groomer'},
	{
		value: 'Medical / Clinic Director',
		label: 'Medical/Clinic Director',
		id: 'medical_clinic_director',
	},
	{
		value: 'Nutrition / Feed Sales',
		label: 'Nutrition / Feed Sales',
		id: 'nutrition_feed_sales',
	},
	{
		value: 'Nutritional Professional',
		label: 'Nutritional Professional',
		id: 'nutritional_professional',
	},
	{value: 'Nutritionist', label: 'Nutritionist', id: 'nutritionist'},
	{
		value: 'Office / Practice Manager',
		label: 'Office/Practice Manager',
		id: 'office_practice_manager',
	},
	{value: 'OTC Retailer', label: 'OTC Retailer', id: 'otc_retailer'},
	{value: 'Pharmacist', label: 'Pharmacist', id: 'pharmacist'},
	{
		value: 'Pharmacy - Staff',
		label: 'Pharmacy - Staff',
		id: 'pharmacy_staff',
	},
	{value: 'Pig Producer', label: 'Pig Producer', id: 'pig_producer'},
	{
		value: 'Poultry Producer',
		label: 'Poultry Producer',
		id: 'poultry_producer',
	},
	{
		value: 'Practice Owner, Non DVM',
		label: 'Practice Owner, Non DVM',
		id: 'practice_owner_non_dvm',
	},
	{
		value: 'Receptionist / Client Service',
		label: 'Receptionist/Client Service',
		id: 'receptionist_client_service',
	},
	{
		value: 'Reseller Store - Staff',
		label: 'Reseller Store - Staff',
		id: 'reseller_store_staff',
	},
	{value: 'SQP', label: 'RAMA / SQP', id: 'sqp'},
	{value: 'Student RAMA', label: 'Student RAMA', id: 'student_rama'},
	{
		value: 'Tierarzt/ Tierärztin',
		label: 'Tierarzt/Tierärztin',
		id: 'tierarzt_tierarztin',
	},
	{value: 'Trainer', label: 'Trainer', id: 'trainer'},
	{value: 'Veterinarian', label: 'Veterinarian', id: 'veterinarian'},
	{
		value: 'Veterinarian, Practice Owner',
		label: 'Veterinarian, Practice Owner',
		id: 'veterinarian_practice_owner',
	},
	{
		value: 'Veterinary Assistant',
		label: 'Veterinary Assistant',
		id: 'veterinary_assistant',
	},
	{
		value: 'Veterinary Nurse',
		label: 'Veterinary Nurse',
		id: 'veterinary_nurse',
	},
	{
		value: 'Veterinary Practice - Other',
		label: 'Veterinary Practice - Other',
		id: 'veterinary_practice_other',
	},
	{
		value: 'Veterinary Practice - Vet',
		label: 'Veterinary Practice - Vet',
		id: 'veterinary_practice_vet',
	},
	{
		value: 'Veterinary Practice - Vet Nurse',
		label: 'Veterinary Practice - Vet Nurse',
		id: 'veterinary_practice_vet_nurse',
	},
	{
		value: 'Veterinary Specialist',
		label: 'Veterinary Specialist',
		id: 'veterinary_specialist',
	},
	{
		value: 'Veterinary Student',
		label: 'Veterinary Student',
		id: 'veterinary_student',
	},
	{
		value: 'Veterinary Surgeon',
		label: 'Veterinary Surgeon',
		id: 'veterinary_surgeon',
	},
	{
		value: 'Veterinary Technician',
		label: 'Veterinary Technician',
		id: 'veterinary_technician',
	},
	{value: 'Wholesaler', label: 'Wholesaler', id: 'wholesaler'},
]

const SALUTATIONS = [
	{
		label: 'Dr.',
		value: 'Dr.',
		id: 'dr',
	},
	{
		label: 'M.',
		value: 'M.',
		id: 'm',
	},
	{
		label: 'Miss',
		value: 'Miss',
		id: 'miss',
	},
	{
		label: 'Mr.',
		value: 'Mr.',
		id: 'mr',
	},
	{
		label: 'Mrs.',
		value: 'Mrs.',
		id: 'mrs',
	},
	{
		label: 'Ms.',
		value: 'Ms.',
		id: 'ms',
	},
	{
		label: 'Mx.',
		value: 'Mx.',
		id: 'mx',
	},
	{
		label: 'Professor',
		value: 'Professor',
		id: 'professor',
	},
]

export {BUSINESS_TYPES, ROLES, SALUTATIONS}
